import { gql } from '@apollo/client';

export const GET_TEST_KINDS = gql`
  query queryTestKinds {
    queryTestKinds {
      kind
      label
    }
  }
`;

export const GET_TEST_CATEGORIES = gql`
  query queryTestCategories {
    queryTestCategories {
      category
      label
    }
  }
`;

export const GET_TEST_STATUSES = gql`
  query queryTestStatuses {
    queryTestStatuses {
      status
      label
      context
    }
  }
`;

export const GET_TEST_SUMMARIES_BY_PAGINATION = gql`
  query queryClinicTestList($input: ClinicTestListInput!) {
    queryClinicTestList(input: $input) {
      list {
        id
        name
        testKind {
          kind
          label
        }
        testStatus {
          status
          label
          context
        }
        serial
        patient {
          name
        }
        testItemList {
          testItem {
            id
          }
        }
        createdAt
      }
      page {
        pageNumber
        totalElements
      }
    }
  }
`;

export const GET_TEST_BY_ID = gql`
  query queryTestById($input: Long!) {
    queryTestById(input: $input) {
      id
      serial
      name
      testKind {
        kind
        label
      }
      testStatus {
        status
        label
        context
      }
      personInCharge {
        id
        name
        phone
      }
      registerClerk {
        id
        name
        phone
      }
      testItemList {
        testItem {
          id
          serial
          name
          testCategory {
            category
            label
          }
          requiredDays
          amount
          sampleCollectingFigure
          shortInformation
          longInformation
          shortReferenceRange
          longReferenceRange
        }
        testReport {
          id
          sampleCount
          unit
          result
          comment
          imageUris
        }
      }
      patient {
        id
        serial
        name
        birth
        gender
        isPregnant
        nationality
        menstrualDate
        nik
        phone
        email
        createdAt
        memo
      }
      createdAt
      testedAt
      canceledAt: cancelledAt
      expectedAt
      collectedAt
      reportedAt
      memo
      organizationNumber
      tester
      checker
    }
  }
`;

export const CANCEL_TEST = gql`
  mutation cancelTest($input: CancelTestInput!) {
    cancelTest(input: $input) {
      id
    }
  }
`;

export const UPDATE_TEST = gql`
  mutation updateTest($input: UpdateTestInput!) {
    updateTest(input: $input) {
      id
    }
  }
`;

export const DELETE_TEST = gql`
  mutation deleteTest($input: Long!) {
    deleteTest(input: $input)
  }
`;

export const GET_TEST_ITEM_SUMMARIES = gql`
  query queryTestItemListWithFilter($input: TestItemListInput!) {
    queryTestItemListWithFilter(input: $input) {
      list {
        id
        serial
        name
        requiredDays
        amount
        testCategory {
          category
          label
        }
        sampleCollectingFigure
        shortInformation
        longInformation
        shortReferenceRange
        longReferenceRange
      }
    }
  }
`;

// 코드에 해당하는 검사 항목을 반환하는 메서드
// ---
// {
//     "input": {
//         "code": "54405586-a995-4dd0-b886-f6340d6e9e8f"
//     }
// }
export const GET_TEST_ITEM_BY_ID = gql`
  query queryTestItemById($input: TestItemInput!) {
    queryTestItemById(input: $input) {
      id
      serial
      name
      testCategory {
        category
        label
      }
      requiredDays
      amount
      sampleCollectingFigure
      shortInformation
      longInformation
      shortReferenceRange
      longReferenceRange
      specimen
    }
  }
`;

export const CREATE_TEST = gql`
  mutation createTest($input: CreateTestInput!) {
    createTest(input: $input) {
      id
    }
  }
`;

export const GET_TEST_TOTAL_COUNT = gql`
  query queryClinicTestList($input: ClinicTestListInput!) {
    queryClinicTestList(input: $input) {
      list {
        testStatus {
          status
          label
          context
        }
      }
      page {
        pageNumber
        totalElements
      }
    }
  }
`;

export const GET_TEST_SUMMARY_WITH_TOTAL_COUNT = gql`
  query queryClinicTestList($input: ClinicTestListInput!) {
    queryClinicTestList(input: $input) {
      list {
        id
        name
        serial
        patient {
          name
        }
        testItemList {
          testItem {
            id
          }
        }
        createdAt
      }
      page {
        pageNumber
        totalElements
      }
    }
  }
`;

export const GET_TEST_BY_PATIENT_ID = gql`
  query queryPatientTestList($input: PatientTestListInput!) {
    queryPatientTestList(input: $input) {
      list {
        id
        serial
        name
        testStatus {
          status
          label
          context
        }
        testItemList {
          testItem {
            id
            serial
            name
            testCategory {
              category
              label
            }
          }
          testReport {
            id
            sampleCount
            unit
            result
            comment
            imageUris
          }
        }
        createdAt
      }
      page {
        pageNumber
        totalElements
      }
    }
  }
`;
